import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IClassifier } from '../../../models/Classifier';
import { ICourseEqualizationFile, ICourseEqualizationInner } from '../../../models/CourseEqualization';
import { AppService } from '../../../services/app.service';
import { CourseEqualizationService } from '../../../services/course-equalization.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { util } from '../shared';

export interface IInnerCourseOptions {
    grades: IClassifier[];
    defaultTheoryGradeId?: string;
    defaultPracticeGradeId?: string;
}

@Component({
    selector: 'app-course-equalization-inner',
    templateUrl: './course-equalization-inner.component.html',
    styleUrls: ['../course-equalization.component.scss']
})
export class CourseEqualizationInnerComponent {
    constructor(
        private app: AppService,
        private service: CourseEqualizationService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set options(value: IInnerCourseOptions) {
        this._options = value;
        this.gradeOptions = value.grades || [];
    }
    
    @Input() set data(value: ICourseEqualizationInner) {
        this._data = value;
        this.model = JSON.parse(JSON.stringify(value));

        if (!this.model.TheoryGradeId && !this.model.IsEqualizedWithNoGrade) {
            this.model.TheoryGradeId = this.options?.defaultTheoryGradeId;
        }

        if (!this.model.PracticeGradeId && !this.model.IsEqualizedWithNoGrade) {
            this.model.PracticeGradeId = this.options?.defaultPracticeGradeId;
        }
    }

    get options() {
        return this._options;
    }

    get data() {
        return this._data;
    }

    readonly outerColumns: ITableColumn[] = [
        { label: 'courseEqualization_lblCourse' },
        { label: 'courseEqualization_lblWeeks' },
        { label: 'courseEqualization_lblEcts' },
        { label: 'courseEqualization_lblTheory' },
        { label: 'courseEqualization_lblPractice' },
        { label: 'courseEqualization_lblAttachments' }
    ];

    readonly util = util;

    model: ICourseEqualizationInner = <ICourseEqualizationInner>{};
    gradeOptions: IClassifier[] = [];

    private _options: IInnerCourseOptions;
    private _data: ICourseEqualizationInner = <ICourseEqualizationInner>{};

    ok() {
        const theory = this.gradeOptions.find(t => t.Id == this.model.TheoryGradeId);
        const practice = this.gradeOptions.find(t => t.Id == this.model.PracticeGradeId);

        this.model.TheoryGrade = theory?.Value;
        this.model.TheoryGradeValue = theory?.Code;
        this.model.PracticeGrade = practice?.Value;
        this.model.PracticeGradeValue = practice?.Code;

        this.activeModal.close({
            model: this.model
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }

    downloadAttachment(attachment: ICourseEqualizationFile) {
        util.downloadAttachment(this.app, this.service, attachment);
    }

    onFullCreditChange(checked: boolean) {
        if (checked) {
            this.model.AcquireEcts = 0;
            this.model.AcquireWeeks = 0;
        }
    }

    onEqualizeWithNoGrade(checked: boolean) {
        if (checked) {
            this.model.TheoryGradeId = null;
            this.model.TheoryGrade = null;
            this.model.PracticeGradeId = null;
            this.model.PracticeGrade = null;
        }
    }
}
